/*
 * CatalogEdit Messages
 *
 * This contains all the text for the Catalog Edit container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.CatalogEdit';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the HomePage container!',
  },
  car: {
    id: `${scope}.car`,
    defaultMessage: 'Automobile',
    description: "Modifica l'auto per la tua offerta",
  },
  images: {
    id: `${scope}.images`,
    defaultMessage: 'Immagini',
    description: "Gestisci le immagini dell'auto",
  },
  offer: {
    id: `${scope}.offer`,
    defaultMessage: 'Offerta',
    description: "Modifica i dati relativi all'offerta",
  },
  childs: {
    id: `${scope}.childs`,
    defaultMessage: 'Variazioni',
    description: "Modifica i prezzi dell'offerta",
  },
  services: {
    id: `${scope}.services`,
    defaultMessage: 'Servizi inclusi',
    description: "Modifica i servizi delll'offerta",
  },
  preview: {
    id: `${scope}.preview`,
    defaultMessage: 'Suggerimenti',
  },
  submit: {
    id: `${scope}.submit`,
    defaultMessage: 'Salva modifiche',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Annulla',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Elimina offerta',
  },
  clone: {
    id: `${scope}.clone`,
    defaultMessage: 'Duplica offerta',
  },
  linkToOffer: {
    id: `${scope}.linkToOffer`,
    defaultMessage: 'Vedi dettaglio offerta',
  },
});
